import React from "react";
import { Link } from "react-router-dom";
import projectLogo from "../assets/Logo.png";

function ThankYou() {
  return (
    <main className="grid min-h-screen place-items-center bg-[#f3f4f8] px-4">
      <section className="w-full max-w-xl rounded-xl bg-white p-8 text-center shadow-md">
        <img
          src={projectLogo}
          alt="CODENAME - K3"
          className="mx-auto h-[64px] w-auto object-contain"
        />
        <h1 className="mt-5 text-3xl font-bold text-slate-900">Thank You</h1>
        <p className="mt-3 text-base text-slate-700">
          Your enquiry has been submitted successfully. Our team will contact you shortly.
        </p>
        <Link
          to="/"
          className="mx-auto mt-6 inline-block rounded-md bg-[#5d627d] px-6 py-2.5 text-base font-semibold text-white hover:bg-[#4f5368]"
        >
          Back To Home
        </Link>
      </section>
    </main>
  );
}

export default ThankYou;
